import { useEffect, useState } from "react";
import { mediaAbs, mediaSrcSet } from "@/lib/media";
import { frameStyle, framedSizes } from "@/lib/framing";

const useDesktop = (enabled) => {
  const q = "(min-width: 1024px)";
  const [d, setD] = useState(() => typeof window !== "undefined" && window.matchMedia(q).matches);
  useEffect(() => {
    if (!enabled) return undefined;
    const m = window.matchMedia(q);
    const on = () => setD(m.matches);
    m.addEventListener("change", on);
    return () => m.removeEventListener("change", on);
  }, [enabled]);
  return d;
};

/** Uploaded media → <picture> with WebP/JPEG srcset + optional framing (focal point/zoom). Falls back on error (never broken). */
export const SmartImg = ({ src, fallback, alt, sizes = "100vw", eager = false, className = "", testid, framing, mobileFraming, ...rest }) => {
  const [failed, setFailed] = useState(false);
  const desktop = useDesktop(!!mobileFraming);
  const url = failed ? fallback : src || fallback;
  if (!url || (failed && (!fallback || fallback === src))) return null;
  const f = failed ? null : (mobileFraming && !desktop ? mobileFraming : framing);
  const sz = framedSizes(sizes, f?.zoom);
  const webp = !failed && mediaSrcSet(url, "webp");
  return (
    <picture className="contents">
      {webp && <source type="image/webp" srcSet={webp} sizes={sz} />}
      <img src={mediaAbs(url)} srcSet={!failed ? mediaSrcSet(url, "jpg") : undefined} sizes={sz} alt={alt}
           loading={eager ? "eager" : "lazy"} decoding="async" onError={() => !failed && setFailed(true)}
           className={className} style={frameStyle(f)} data-testid={testid} {...rest} />
    </picture>
  );
};
